import { Link } from '@tanstack/react-router'
import { PencilLine } from 'lucide-react'

import type { CustomerDetail } from '@/api/types'
import { Button } from '@/components/ui/button'

import { useCustomerPermissions } from './permissions'

/**
 * The way into the amendment screen.
 *
 * Offered only where the amendment could actually be made: the update permission, the PII
 * permission the whole-record save depends on, and a file that is not currently with a supervisor.
 * A button that leads to a refusal panel is a worse screen than no button — this is a record an
 * operator opens dozens of times a day, and the presence of the control is what tells them whether
 * the change they are about to be asked for is one they can make.
 */
export function CustomerAmendAction({ customer }: { customer: CustomerDetail }) {
  const permissions = useCustomerPermissions()

  if (!permissions.canUpdate || !permissions.canViewPii || customer.kycStatus === 'PendingReview') {
    return null
  }

  return (
    <Button asChild variant="secondary">
      <Link to="/customers/$customerId/edit" params={{ customerId: customer.id }}>
        <PencilLine />
        Amend
      </Link>
    </Button>
  )
}
